// Этот файл генерируется автоматически, его не следует редактировать вручную
import animationMainProducts from '@/widgets/animationMainProducts.js';
import animationPrenatalBanner from '@/widgets/animationPrenatalBanner.js';
import animationProductPasta from '@/widgets/animationProductPasta.js';
import animationProductPastaUse from '@/widgets/animationProductPastaUse.js';
import animationProductPills from '@/widgets/animationProductPills.js';
import animationProductPillsUse from '@/widgets/animationProductPillsUse.js';
import animationUse from '@/widgets/animationUse.js';
import animationWhereBuyPackage from '@/widgets/animationWhereBuyPackage.js';
import globalEventButton from '@/widgets/globalEventButton.js';
import headerScroll from '@/widgets/headerScroll.js';
import popupFootnotes from '@/widgets/popupFootnotes.js';
import popupGrass from '@/widgets/popupGrass.js';
import popupMenu from '@/widgets/popupMenu.js';
import popupOils from '@/widgets/popupOils.js';
import prenatalFaq from '@/widgets/prenatalFaq.js';
import prenatalTabs from '@/widgets/prenatalTabs.js';
import scrollDown from '@/widgets/scrollDown.js';
import scrollSlider from '@/widgets/scrollSlider.js';
import scrollSliderChange from '@/widgets/scrollSliderChange.js';
import scrollTop from '@/widgets/scrollTop.js';
import sliderArticles from '@/widgets/sliderArticles.js';
import sliderWhereBuy from '@/widgets/sliderWhereBuy.js';
import testBlock from '@/widgets/testBlock.js';

export default {
  'animationMainProducts': async () => { return { default: animationMainProducts }; },
  'animationPrenatalBanner': async () => { return { default: animationPrenatalBanner }; },
  'animationProductPasta': async () => { return { default: animationProductPasta }; },
  'animationProductPastaUse': async () => { return { default: animationProductPastaUse }; },
  'animationProductPills': async () => { return { default: animationProductPills }; },
  'animationProductPillsUse': async () => { return { default: animationProductPillsUse }; },
  'animationUse': async () => { return { default: animationUse }; },
  'animationWhereBuyPackage': async () => { return { default: animationWhereBuyPackage }; },
  'collapse': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/collapse.js'),
  'globalEventButton': async () => { return { default: globalEventButton }; },
  'headerScroll': async () => { return { default: headerScroll }; },
  'popupFootnotes': async () => { return { default: popupFootnotes }; },
  'popupGrass': async () => { return { default: popupGrass }; },
  'popupMenu': async () => { return { default: popupMenu }; },
  'popupOils': async () => { return { default: popupOils }; },
  'prenatalFaq': async () => { return { default: prenatalFaq }; },
  'prenatalTabs': async () => { return { default: prenatalTabs }; },
  'scrollDown': async () => { return { default: scrollDown }; },
  'scrollSlider': async () => { return { default: scrollSlider }; },
  'scrollSliderChange': async () => { return { default: scrollSliderChange }; },
  'scrollTop': async () => { return { default: scrollTop }; },
  'sliderArticles': async () => { return { default: sliderArticles }; },
  'sliderWhereBuy': async () => { return { default: sliderWhereBuy }; },
  'specBanner': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/specBanner.js'),
  'testBlock': async () => { return { default: testBlock }; }
};
